module.exports = __webpack_public_path__ + "static/media/Logo tirto biru tua.1ec1c703.png";